<template>
  <div>

    <Head title="Get a Run in Project" />
    <h1 class="mb-4 text-4xl font-bold text-center text-blue-600">
      Get a Run in Project
    </h1>
    <p class="text-gray-400 text-center max-w-xl m-auto mb-8">
      Please fill the form below to receive a quote for you project, Feel free to add much details as needed.
    </p>

    <div class="flex items-center justify-center max-w-5xl text-center m-auto mt-20 mb-10">
      <div class="rounded-full px-4 py-3"
        :class="form.step >= 1 ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-600'">1</div>
      <div class="rounded w-20 h-2 mx-3" :class="form.step >= 2 ? 'bg-blue-800' : 'bg-gray-200'">&nbsp;</div>
      <div class="rounded-full px-4 py-3"
        :class="form.step >= 2 ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-600'">2</div>
      <div class="rounded w-20 h-2 mx-3" :class="form.step >= 3 ? 'bg-blue-800' : 'bg-gray-200'">&nbsp;</div>
      <div class="rounded-full px-4 py-3"
        :class="form.step >= 3 ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-600'">3</div>
      <div class="rounded w-20 h-2 mx-3" :class="form.step >= 4 ? 'bg-blue-800' : 'bg-gray-200'">&nbsp;</div>
      <div class="rounded-full px-4 py-3"
        :class="form.step >= 4 ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-600'">4</div>
      <div class="rounded w-20 h-2 mx-3" :class="form.step >= 5 ? 'bg-blue-800' : 'bg-gray-200'">&nbsp;</div>
      <div class="rounded-full px-4 py-3"
        :class="form.step >= 5 ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-600'">5</div>
    </div>

    <div class="rounded w-full max-w-xl text-center m-auto h-px bg-gray-200 mb-10">&nbsp;</div>
    <form @submit.prevent="store">
      <StepOne v-if="form.step == 1" :value="stepModel" :project="project" @input="updateForm($event)" />

      <StepTwo v-if="form.step == 2" :value="stepModel" :props="stepTwoProps" :filter-by="filterBy"
        @input="updateForm($event)" @move="moveToSection($event)" />

      <StepThree v-if="form.step == 3" :value="stepModel" :props="stepThreeProps" :filter-by="filterBy"
        @input="updateForm($event)" @move="moveToSection($event)" />

      <StepFour v-if="form.step == 4" :value="stepModel" :accessories="accessories" :systemId="form.system"
        @input="updateForm($event)" />

      <StepFive v-if="form.step == 5" :run="run" :value="stepModel" :errors="form.errors" @input="updateForm($event)" />
    </form>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout.vue'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import pick from 'lodash/pick'
import StepOne from './Partials/Create/StepOne.vue'
import StepTwo from './Partials/Create/StepTwo.vue'
import StepThree from './Partials/Create/StepThree.vue'
import StepFour from './Partials/Create/StepFour.vue'
import StepFive from './Partials/Create/StepFive.vue'

let callGetFilters = {
  handler: throttle(function () { this.getFilters() }, 150),
  deep: true,
}

export default {
  components: {
    Head,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
  },
  layout: Layout,
  remember: 'form',
  props: {
    project: Object,
    systems: Object,
    widths: Array,
    edges: Array,
    canBeSloped: Boolean,
    loadClass: Array,
    materials: Array,
    types: Array,
    compliances: Array,
    grates: [Object, Array],
    outlets: Array,
    outletTypes: Array,
    outletSizes: Array,
    depths: Object,
    stepSize: Number,
    minDepth: Number,
    filters: Object,
    channelPositions: [Object, Array],
    accessories: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      filterBy: {
        loadClass: this.filters.loadClass ? this.filters.loadClass.map((c) => parseInt(c)) : [],
        materials: this.filters.materials ? this.filters.materials.map((m) => parseInt(m)) : [],
        types: this.filters.types ? this.filters.types.map((t) => parseInt(t)) : [],
        compliances: this.filters.compliances ? this.filters.compliances.map((c) => parseInt(c)) : [],
      },
      form: this.$inertia.form({
        step: 1,
        name: null,
        system: this.filters.system ?? null,
        edge: this.filters.edge ?? null,
        width: this.filters.width ?? null,
        grate: null,
        length: 0,
        depth: null,
        channel_depth: null,
        depth_restriction: null,
        devices: true,
        outlet: null,
        outlet_position: null,
        outlet_type_id: null,
        outlet_size: null,
        max_depth_channel: null,
        selectedAccessories: [], // Field for selected accessories
      }),
    }
  },
  computed: {
    stepModel() {
      return this.form
    },
    stepTwoProps() {
      return {
        systems: this.systems,
        widths: this.widths,
        edges: this.edges,
        loadClass: this.loadClass,
        materials: this.materials,
        types: this.types,
        compliances: this.compliances,
        grates: this.grates,
      }
    },
    stepThreeProps() {
      return {
        system: parseInt(this.form.system),
        canBeSloped: this.canBeSloped,
        outlets: this.outlets,
        outletTypes: this.outletTypes,
        outletSizes: this.outletSizes,
        depths: this.depths,
        stepSize: this.stepSize,
        minDepth: this.minDepth,
        channelPositions: this.channelPositions,
        priceListId : this.project.price_list_id,
      }
    },
    run() {
      let { name, system, width, edge, length, grate, channel_depth, depth, outlet, outlet_type_id, outlet_size, selectedAccessories } = this.form
      system = system ? this.systems.find((s) => s.id == system) : {}
      let outletType = outlet_type_id ? this.outletTypes.find((ot) => ot.id == outlet_type_id) : {}

      return {
        'name': name,
        'system': system.name,
        'width': width ? this.widths.find((e) => e.value == width).label : '',
        'edge': edge ? this.edges.find((e) => e.id == edge).name : '',
        'length': `${this.MetricToFeet(length)} feet / ${length} meters`,
        'channel_depth': channel_depth ? this.depths.find((e) => e.value == channel_depth).label : '',
        'depth': depth == 1 ? 'Sloped Run' : 'Constant Depth',
        'outlet': {
          'name': outlet ? this.outlets.find((o) => o.id == outlet).name : '',
          'type': outletType.name,
          'size': outlet_size ? `${outlet_size} in / ${this.InchesToMelimeters(outlet_size)} mm` : false,
        },
        'grate': grate == null ? null : {
          'class': grate.class,
          'icon': this.loadClass.find((e) => e.id == grate.class_id).icon,
          'material': grate.material,
          'compliances': grate.compliances,
        },
        'selectedAccessories': selectedAccessories || [],
        filters: [
          {
            img: system.img,
            label: system.name,
          },
          {
            img: grate?.img,
            label: grate?.label,
            compliances: grate?.compliances,
            parts: grate?.parts,
          },
          {
            label: outletType?.name,
            img: outletType?.img_src,
          },
        ],
      }
    },
  },
  watch: {
    'form.system': callGetFilters,
    'form.width': callGetFilters,
    'form.edge': callGetFilters,
    'filterBy.loadClass': callGetFilters,
    'filterBy.materials': callGetFilters,
    'filterBy.types': callGetFilters,
    'filterBy.compliances': callGetFilters,
    'form.depth': {
      handler: throttle(function () {
        if (this.form.depth && this.form.system == 2) {
          this.form.devices = true
        }
        this.getFilters()
      }, 150),
      deep: true,
    },
    'form.channel_depth': callGetFilters,
    'form.outlet': callGetFilters,
    'form.outlet_type_id': callGetFilters,
    'form.outlet_size': callGetFilters,
    'form.max_depth_channel': callGetFilters,
  },
  mounted() {
    if (this.form.name) {
      this.step = 2
    }

    if (this.form.grate) {
      this.step = 3
    }
  },
  methods: {
    store() {
      this.form
        .transform((data) => {
          // Transform form data for submission
          const transformedData = {
            ...data,
            system_id: data.system,
            edge_id: data.edge,
            width_id: data.width,
            class_id: data.grate?.class_id,
            material_id: data.grate?.material_id,
            design_id: data.grate?.design_id,
            outlet_id: data.outlet,
            selectedAccessories: data.selectedAccessories
          };

          // Clean up any undefined values
          Object.keys(transformedData).forEach(key => {
            if (transformedData[key] === undefined) {
              delete transformedData[key];
            }
          });

          return transformedData;
        })
        .post(`/projects/${this.project.id}/runs`, {
          preserveState: true,
          onError: (errors) => {
            if (errors.name) {
              this.form.step = 1
            }
            if (errors.length || errors.outlet_position) {
              this.form.step = 3
            }
          },
        })
    },
    getFilters() {
      let filterBy = pickBy(
        pick(this.filterBy, ['loadClass', 'materials', 'types', 'compliances']),
      )

      let form = pickBy(
        pick(this.form, ['system', 'width', 'edge', 'depth', 'channel_depth', 'outlet', 'outlet_type_id', 'outlet_size']),
      )

      // Remove channel_depth if it's null or if we're on steps 1-2
      if (!form.channel_depth || this.form.step <= 2) {
        delete form.channel_depth
      }

      let params = {
        ...filterBy,
        ...form,
      }

      this.$inertia.get(
        `/projects/${this.project.id}/runs/create`,
        params, {
        preserveState: true,
        preserveScroll: true,
      })
    },
    updateForm({ key, value }) {
      if (!key.includes('form')) {
        this.form.step = value
        return
      }
      let arr = key.split('.')
      let k = arr[arr.length - 1]
      this.form[k] = value
    },
    moveToSection(section) {
      setTimeout(() => {
        let scrollRegion = document.getElementById('scroll-region')
        let el = document.getElementById(section)
        if (el) {
          scrollRegion.scroll({
            top: el.offsetTop - 100,
            left: 0,
            behavior: 'smooth',
          })
        }
      }, 200)
    },
  },
}
</script>
